import { OrderProduct } from "./Order";

export enum AppliedCouponDiscountFields {
    Id = "id",
    Name = "nombreCupon",
    DiscountTotal = "totalConDescuento",
    OriginalTotal = "totalOrden",
    FreeShipping = "envioGratis",
}

export interface AppliedCouponDiscount {
    [AppliedCouponDiscountFields.Id]: string;
    [AppliedCouponDiscountFields.Name]: string;
    [AppliedCouponDiscountFields.DiscountTotal]: number;
    [AppliedCouponDiscountFields.OriginalTotal]: number;
    [AppliedCouponDiscountFields.FreeShipping]: boolean;
}

export enum CouponApplyRequestFields {
    Name = "nombreCupon",
    Products = "productos",
}

export interface CouponApplyRequest {
    [CouponApplyRequestFields.Name]: string;
    [CouponApplyRequestFields.Products]: OrderProduct[];
}
